import { jsPDF } from 'jspdf';
import { TRACK_PROFILES } from './track';
import { trackWork } from './trackModes';
import { waitState } from './agents';
import { clean, mapSnapshot, overviewView, safeName } from './exporters';
import { APP_INFO } from './license';

// one-page field record (Schlagkartei) of one plot: master data, map, every pass (spray, fertiliser, mowing …)
export async function plotPdf(t, project, rep) {
  const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'landscape' });
  const M = 12, W = 273, dt = (v) => new Date(v).toLocaleDateString(t.locale);
  const passes = (project.tracks || []).filter((tr) => tr.meta?.plot === rep.id).sort((a, b) => a.start - b.start);
  doc.setFillColor(21, 128, 61); doc.rect(0, 0, 297, 22, 'F');
  doc.setTextColor(255); doc.setFont('helvetica', 'bold'); doc.setFontSize(15);
  doc.text(clean(`${t.pkTitle}: ${rep.title}`), M, 10);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
  doc.text(clean(`${project.title || ''} · ${rep.address || project.address || ''} · ${APP_INFO.name} · ${new Date().toLocaleString(t.locale)}`), M, 17);
  doc.setTextColor(20);
  const pts = passes.flatMap((tr) => tr.pts.map((p) => [p.lat, p.lon]));
  const anchor = rep.lat != null ? [[rep.lat, rep.lon]] : [];
  try {
    const img = await mapSnapshot(overviewView([...pts, ...anchor]), passes.map((tr) => ({ pts: tr.pts.map((p) => [p.lat, p.lon]), color: TRACK_PROFILES[tr.profile]?.color || '#15803d' })), { noCross: true }, 700, 460);
    if (img) doc.addImage(img, 'JPEG', M, 28, 92, 60);
  } catch { /* map optional */ }
  const tot = passes.reduce((a, tr) => a + (trackWork(tr).ha || 0), 0);
  const info = [[t.pkPlot, rep.title], [t.pkCoord, rep.lat != null ? `${rep.lat.toFixed(6)}, ${rep.lon.toFixed(6)}` : '-'], [t.pkPasses, String(passes.length)], [t.pkWorked, `${tot.toFixed(2)} ha`], [t.pkNote, (rep.description || '').slice(0, 160)]];
  const ws = waitState(project.tracks, rep.id);
  if (ws) info.splice(4, 0, [t.wtLabel, `${ws.st === 'green' ? t.wtFree : t.wtUntil} ${new Date(ws.end).toLocaleDateString(t.locale)}${ws.agent ? ` (${ws.agent})` : ''}`]);
  let y = 32;
  info.forEach(([k, v]) => { doc.setFont('helvetica', 'bold'); doc.setFontSize(9); doc.text(clean(k), M + 98, y); doc.setFont('helvetica', 'normal'); doc.text(doc.splitTextToSize(clean(v), 120).slice(0, 3), M + 140, y); y += 9; });
  const cols = [[t.colDate, 20], [t.tlAct, 50], [t.tlf_agent, 38], [t.tlRate, 30], [t.tlArea, 26], [t.pkUse, 22], [t.tlf_wind, 22], [`${t.tlf_driver} / ${t.tlf_vehicle}`, 65]];
  y = 98;
  const row = (cells, bold) => {
    doc.setFont('helvetica', bold ? 'bold' : 'normal'); doc.setFontSize(8.4); doc.setTextColor(20);
    let x = M; cells.forEach((c, i) => { doc.text(clean(String(c ?? '')).slice(0, 48), x, y, { maxWidth: cols[i][1] - 2 }); x += cols[i][1]; });
    y += 6.2; doc.setDrawColor(226, 232, 240); doc.line(M, y - 4, M + W, y - 4);
  };
  row(cols.map((c) => c[0]), true);
  if (!passes.length) { doc.setFontSize(9); doc.text(clean(t.pkNone), M, y + 2); }
  let hidden = 0;
  passes.forEach((tr) => {
    if (y > 190) { hidden++; return; }
    const w = trackWork(tr), m = tr.meta || {};
    row([dt(tr.start), t['trkP_' + tr.profile], m.agent || (m.fertType ? t['tlo_fertType_' + m.fertType] : ''), m.rate ? `${m.rate} l/ha` : m.fertRate ? `${m.fertRate} kg/ha` : '', w.ha != null ? `${w.ha.toFixed(2)} ha` : '', w.use != null ? `${w.use.toFixed(1)} ${w.useUnit}` : '', m.wind ? `${m.wind} m/s${m.windOver ? ' !' : ''}` : '', [m.driver, m.vehicle, m.implement].filter(Boolean).join(' / ')]);
  });
  if (hidden) { doc.setFontSize(8); doc.setTextColor(185, 28, 28); doc.text(clean(`+ ${hidden} ${t.pkPasses} → ${t.tlTitle}`), M, y + 1); }
  doc.setFontSize(7); doc.setTextColor(120); doc.text(clean(`${APP_INFO.name} · ${t.pkTitle}`), M, 204);
  doc.save(`${safeName(`Schlagkartei ${rep.title}`)}.pdf`);
}
